import React from "react";

const FilterSkeleton = () => {
  return (
    <div className="h-[56px] md:h-[44px] w-full flex flex-col md:flex-row mt-0 md:gap-16 bg-gray-300 py-[11px]  md:py-[4px] px-2 rounded-lg overflow-hidden">
        <div className="flex items-center w-full md:w-1/2 h-[34px] md:h-full mb-0  bg-gray-200  rounded-lg animate-pulse"></div>
        <div className="hidden md:flex items-center w-full md:w-1/2 h-[34px] md:h-full bg-gray-200 rounded-lg animate-pulse"></div>
    </div>
  );
};

export default FilterSkeleton;
